import { render, staticRenderFns } from "./ProviderCardSkeleton.vue?vue&type=template&id=8fbf09ee&scoped=true&"
import script from "./ProviderCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProviderCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCardSkeleton.vue?vue&type=style&index=0&id=8fbf09ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf09ee",
  null
  
)

component.options.__file = "ProviderCardSkeleton.vue"
export default component.exports